
<template>
    <footer class="app-footer">
        <div>
            <p>Copyright 2013 - {{ new Date().getFullYear() }} Roadink GLB . All Rights Reserved</p>
            <p ><a class="icp" href="https://beian.miit.gov.cn/">粤ICP备16022189号-1</a></p>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'AppFooter'
};

</script>

<style scoped>
.app-footer {
    background-color: #1a3b69;
    padding: 20px 0;
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    color: #ffffff;
}

.icp {
    color: #ffffff;
}

</style>